import { slot } from "@fluentui/react-components";
import type { AppFlexMenuProps, AppFlexMenuState } from "./AppFlexMenu.types";
import {
  useAppFlexMenuClassName,
  useAppFlexMenuStyles,
} from "./AppFlexMenu.styles";

export const useAppFlexMenu = (props: AppFlexMenuProps): AppFlexMenuState => {
  const { expandMaxHeight, headerProps, footerProps, defaultRender } = props;

  const classNames = useAppFlexMenuStyles();
  const rootClassName = useAppFlexMenuClassName(expandMaxHeight || false);

  const containerSlot = slot.always(props.containerSlot, {
    defaultProps: {
      className: rootClassName,
    },
    elementType: "div",
  });

  const headerSlot = props.headerProps
    ? slot.optional(props.headerSlot, {
        defaultProps: {
          className: classNames.header,
        },
        elementType: "div",
        renderByDefault: true,
      })
    : undefined;

  const bodySlot = slot.always(props.bodySlot, {
    defaultProps: {
      className: classNames.container,
    },
    elementType: "div",
  });

  const footerSlot = slot.always(props.footerSlot, {
    defaultProps: {
      className: classNames.footer,
    },
    elementType: "div",
  });

  return {
    ...props,
    components: {
      containerSlot: "div",
      headerSlot: "div",
      bodySlot: "div",
      footerSlot: "div",
    },
    containerSlot,
    headerSlot,
    bodySlot,
    footerSlot,
    headerProps,
    footerProps,
    defaultRender,
  } as AppFlexMenuState;
};
